import { defaultPerTabMapSettings } from '~/reducers/mapSettingsSlice/constants';

const depotDefaults = {
    showHqDepot: defaultPerTabMapSettings.showHqDepot,
    showSatelliteDepots: defaultPerTabMapSettings.showSatelliteDepots,
    showDepotLabels: defaultPerTabMapSettings.showDepotLabels
};

/**
 * NOVA-2246
 *
 * Add depot marker visibility settings to per-tab map settings
 */
export default function (state) {
    const { mapSettings } = state;

    return {
        ...state,
        mapSettings: {
            ...mapSettings,
            plan: {
                ...depotDefaults,
                ...mapSettings?.plan
            },
            dispatched: {
                ...depotDefaults,
                ...mapSettings?.dispatched
            },
            completed: {
                ...depotDefaults,
                ...mapSettings?.completed
            }
        }
    };
}
